import { EvaluationType } from '../domain/types';

export const evaluationTypeLabels: Record<EvaluationType, string> = {
  PHYSICAL: 'In loco',
  VIDEO: 'Video valutazione',
  REMOTE: 'Da remoto',
};
